export default class Typed {
  constructor(renderedArray, {strings=[], typeSpeed = 20, onBegin=(() => {}), onStop=(() => {}), onComplete=(() => {}), preStringTyped=(() => {})}) {
    this.requestAnimationFrameTime = null
    if (typeof renderedArray instanceof Array)  throw new Error('第一个参数需要为一个字符串数组')
    this.renderedArray = renderedArray
    this.typeSpeed = typeSpeed
    this.currentPos = 0
    this.strings = strings
    this.onBegin = onBegin
    this.onStop = onStop
    this.onComplete = onComplete
    this.preStringTyped = preStringTyped
    this.stringsText = this.strings.join('')
    this.beign()
  }
  beign() {
    // if (!window.requestAnimationFrame) return
    // this.requestAnimationFrameTime = window.requestAnimationFrame(this.run.bind(this))
    this.requestAnimationFrameTime = setTimeout(this.run.bind(this), 1000 / this.typeSpeed)
    this.onBegin()
  }
  run() {
    if (this.currentPos >= this.stringsText.length) {
      // window.cancelAnimationFrame(this.requestAnimationFrameTime)
      clearTimeout(this.requestAnimationFrameTime)
      this.requestAnimationFrameTime = null
      this.onComplete()
    } else {
      this.renderedArray.push(this.stringsText[this.currentPos])
      this.currentPos++
      // this.requestAnimationFrameTime = window.requestAnimationFrame(this.run.bind(this))
      this.requestAnimationFrameTime = setTimeout(this.run.bind(this), 1000 / this.typeSpeed)
    }
  }
  stop() {
    // window.cancelAnimationFrame(this.requestAnimationFrameTime)
    clearTimeout(this.requestAnimationFrameTime)
    this.requestAnimationFrameTime = null
    this.onStop()
  }
}